import React from 'react';

import './stylings/Footer.css';


export default function Footer() {
	return (
		<footer>
				<div className="container">
					<div className="footer__inner-left clearfix">
						<ul className="footer__social">
							<li><a href="https://www.facebook.com/koblenzkompass.koko" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook"></i></a></li>
							<li><a href="https://www.instagram.com/koblenz_kompass/" target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram"></i></a></li>
						</ul>
						
						
						<div className="footer__inner-right">
							<p className="footer__copyright">Copyright &copy; 2013-2018</p>			
							<a className="footer__legal" href="/impressum">Impressum</a>		
							<a className="footer__legal" href="/datenschutz">Datenschutz</a>
						</div>
					</div>
				</div>
		</footer>		
	);
}


// WEBPACK FOOTER //
// ./src/components/Footer.js